import axiosPrivateMl from "./axiosPrivateMl"

export const VerifyFbAuthToken = async (token) => {
  return axiosPrivateMl.post("/verify_fb_auth_token", { fb_auth_token: token })
}
